module.exports = __webpack_public_path__ + "static/media/logo-sm.92107b2b.png";